const CSS = `
#tooltip {
  position: fixed;
  z-index: 16;
  padding: 4px 8px 5px;
  border-radius: 2px;
  background: rgba(9, 8, 7, 0.9);
  color: #e9e2d0;
  font-family: "Silkscreen", monospace;
  font-size: 11px;
  line-height: 1;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  white-space: nowrap;
  pointer-events: none;
  opacity: 0;
  transition: opacity 120ms ease;
}
#tooltip[data-visible="true"] {
  opacity: 1;
}
`;

/** a name plate that follows the pointer, for things in the world you can take */
export class Tooltip {
  private readonly root: HTMLDivElement;

  constructor() {
    const style = document.createElement("style");
    style.textContent = CSS;
    document.head.appendChild(style);

    this.root = document.createElement("div");
    this.root.id = "tooltip";
    this.root.dataset.visible = "false";
    document.body.appendChild(this.root);
  }

  show(text: string, x: number, y: number): void {
    if (this.root.textContent !== text) this.root.textContent = text;
    const width = this.root.offsetWidth || 90;
    const height = this.root.offsetHeight || 20;
    const left = Math.min(x + 14, window.innerWidth - width - 8);
    const top = Math.min(y + 16, window.innerHeight - height - 8);
    this.root.style.left = `${Math.max(8, left)}px`;
    this.root.style.top = `${Math.max(8, top)}px`;
    this.root.dataset.visible = "true";
  }

  /** centred over a target, sitting above it — used for slots */
  showAbove(
    text: string,
    target: { left: number; top: number; width: number },
    bounds?: { left: number; right: number },
  ): void {
    if (this.root.textContent !== text) this.root.textContent = text;
    const width = this.root.offsetWidth || 90;
    const height = this.root.offsetHeight || 20;
    const low = bounds ? bounds.left + 5 : 8;
    const high = Math.min(
      bounds ? bounds.right - width - 5 : window.innerWidth - width - 8,
      window.innerWidth - width - 8,
    );
    const left = Math.min(
      Math.max(low, target.left + target.width / 2 - width / 2),
      Math.max(low, high),
    );
    const above = target.top - height - 8;
    const top = above < 8 ? target.top + target.width + 8 : above;
    this.root.style.left = `${left}px`;
    this.root.style.top = `${top}px`;
    this.root.dataset.visible = "true";
  }

  hide(): void {
    this.root.dataset.visible = "false";
  }
}
